const Header = () => {
  return (
    <header className="text-4xl text-center text-green-600 font-medium py-4">
      <h1>Time Converter</h1>
    </header>
  );
};

export default Header;
